//引入安装的axios插件
import axios from 'axios'
import common from "./common";

const http = function(requestData) {
    return new Promise((resolve, reject) => {

        var getRequestData = {
            "randomString": function (len) {
                len = len || 32;
                var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
                /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
                var maxPos = chars.length;
                var pwd = '';
                for ( var i = 0; i < len; i++) {
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                }
                return pwd;
            },
            "getTs":function(){
                return Date.parse(new Date())/1000
            },
            "getCt":function(){
                return "h5";
            },
            "getSi":function(){
                return this.randomString(8); //8位的id  session_id  会话的标识
            },
            "getVn":function(){
                return "1.0";
            },
            "getDi":function(){ //设备标识 种在localS里面
                var di;
                if(!window.localStorage){
                    //浏览器不支持
                    di = this.randomString();
                }else{
                    //主逻辑业务
                    di = localStorage.getItem("di");
                    if(di == null || di.length != 32){
                        di = this.randomString(32); //32位随机
                        localStorage.setItem("di",di);
                    }
                }
                return di;
            },
            "getAppHost":function(){
                return process.env.APP_HOST;
            },
            "getAppUrl":function(uri){
                var ts =  this.getTs();//时戳
                var ct =  this.getCt(); //客户端
                var si =  this.getSi();
                var vn =  this.getVn(); //版本
                var di =  this.getDi(); //客户端设备
                var host = this.getAppHost();
                return host+uri+'/?ct='+ct+'&ts='+ts+'&si='+si+'&vn='+vn+'&di='+di;
            }
        }
        //错误吗
        var errorCode = {
            "SUCCESS"       :0,//成功
            "USER_NO_LOGIN" :1600001,//用户未登录
            "NO_SYS_USER"   :2222601
        }


        //headers默认传递json格式数据，这里也可以设置token，每次调用都会携带
        requestData.headers = {'content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'};

        var url = getRequestData.getAppUrl(requestData.url);
        //发送请求
        axios.defaults.timeout = 5000; //请求超时5秒
        axios.defaults.withCredentials = true;
        axios({
            method: requestData.method,
            url: url,
            data: requestData.data,
            headers: requestData.headers
        }).then(res => {
          //根据返回的状态码判断，注意res返回的并不一定都是status，比如小程序就是statusCode
          if (res.status == 200) {

            //这里我们只需要获取返回的data中的数据即可
              if(res.data.code  ==  errorCode.USER_NO_LOGIN && requestData.redirect !== false){
                  //跳转登录
                  window.location.href="/login";
              }else if(res.data.code == errorCode.NO_SYS_USER){
                  alert("您是非机构用户，请联系客服升级机构用户");
                  window.location.href="//m.jinku.com"
              }else{
                  resolve(res.data);
              }

          } else {
            reject(res);
          }

        }).catch(err => {
            reject(err);
        })

    })
};

export default http



// WEBPACK FOOTER //
// ./src/lib/http.js